import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Poshmark'
        title="Posh N' Sip: A Party for Poshmark Sellers"
      >
        <h3>How Posh N' Sip Works </h3>
        <p>
          Posh N' Sip is a community-based event for Poshmark sellers to connect and chat with fellow Poshers. You can
          discuss, share tips, chat, and have an amazing time with your new friends, also known as Posh Pals (Pffs), to
          spread #PoshLove.{' '}
        </p>
        <p>
          These meetups are facilitated by Poshmark but usually hosted by locals. Due to the pandemic, these events have
          been shifted virtually but still with the same goal- to connect you with like-minded people who share the same
          passion and interests.{' '}
        </p>

        <h3>How to Join Posh N' Sip </h3>
        <p>
          To join a Posh N' Sip event, simply go to your events page and select the date. Click the date to get the full
          details and register for the event.
        </p>
        <p>Here are the most common formats of Posh N' Sip Events you can participate in:</p>
        <ul>
          <li>
            <strong>Intimate Gathering</strong> - A local host usually holds these events from a small group of Posh
            pals. These events are ideal for Poshers who are just getting started to learn more about effective selling
            techniques.{' '}
          </li>
          <li>
            <strong>Social Event</strong> - This event is one of the most typical get-togethers held on Posh N Sips.
            Poshers can meet up to have brunch or coffee and talk anything about Poshmark.{' '}
          </li>
          <li>
            <strong>Seminar</strong> - This event is perfect for all kinds of sellers, from a newbie to power sellers. A
            Poshmark expert usually facilitates and hosts these events to discuss new Poshmark tools, tips, and
            techniques that Poshers can use to get familiarized with the ins and outs of Poshmark.{' '}
          </li>
        </ul>

        <h3>Posh N' Sips Hosts </h3>
        <p>
          Anyone can be a host of these events. As long as you are a Posher located in the United States or Canada, you
          are qualified to be a host. To become a host, simply apply on their website and fill up the application form.
          You will be asked what type of events you want to host, along with your details and the virtual event link or
          the location where the event will be held.{' '}
        </p>
        <p>Here are the most typical type of events you can host on Poshmark: </p>
        <ol>
          <li>
            <strong> Virtual / Social</strong> - Due to the pandemic that the world is currently facing, live events
            migrated to virtual Posh N Sips but with the same goal and agenda. You can still meet fellow resellers by
            joining an event link found on the events page. Simply click the date of the event link and register to
            join.{' '}
          </li>
          <li>
            <strong> Posh N' Coffee</strong> - This is the type of Posh N' Sips event where it is like going out with
            your colleagues to grab a cup of coffee or enjoy happy hours! These coffee edition events are usually held
            in coffee shops such as Starbucks to talk about the Poshmark app, exchange tips, and learn best practices in
            starting a Poshmark business. For full details of the event discussion and topics, you may head on the
            events page, then Event, Select a date, and then finally Full details.{' '}
          </li>
          <li>
            <strong> Posh N' List</strong> - This type of Posh N' list lets you bring items from your Poshmark closet
            that you want to list or any tools and props you want to use in your listings. Aside from the usual
            get-together, you can bring items other attendees may like to purchase. While most of the work is done by
            the host, it still needs to be approved and facilitated by Poshmark. Posh N Sip host is given a Poshmark
            branded host kit with tips on how to plan your event successfully. Poshmark also helps you by marketing your
            event to the community and sharing your events to pm_editor in the United States or Canada.{' '}
          </li>
        </ol>
        <p>
          These events are being held virtually (temporarily) until further notice due to social distancing mandated
          protocols. The good news is, whether you are located in the U.S. or Canada, you can attend these virtual
          events anywhere at any time!{' '}
        </p>

        <h3>Benefits of Poshmark Events for Sellers </h3>
        <p>
          <strong>Networking</strong> - Posh N' Sips is a networking event for Poshmark sellers. These events are hosted
          by various organizers in different cities and usually last for two hours. The organizer has the responsibility
          of inviting vendors, buyers, and bloggers to attend this gathering. It can be beneficial for both sellers and
          buyers because they get to meet new people with similar interests and find some cool items at a discounted
          price. Sellers also have the opportunity to network with other local vendors that could potentially become
          customers.{' '}
        </p>
        <p>
          <strong>Engagement</strong> - Keeping poshers engaged is vital to Poshmark. These events keep all the users
          involved and are one of Poshmark's growth strategies. It also makes sellers feel less isolated as they can
          talk with like-minded sellers and exchange tips and tricks to sell more effectively on Poshmark.
        </p>
        <p>
          <strong>Growth and Learnings</strong> - These events are essential, especially for Poshmark sellers that are
          just getting started on the platform. Seminars are being held where new poshers can ask questions about the
          ins and outs of Poshmark. Veteran power sellers can also share effective selling strategies to help new
          sellers grow their following and sell items in their Poshmark closets faster.{' '}
        </p>
        <p>
          These get-togethers are an excellent venue for exchanging tips, networking, and making memories for all its
          users, also known as "Poshers." You can also share these events on your Facebook, Instagram, and other social
          media accounts to encourage more friends to join (even if they're not on Poshmark yet.){' '}
        </p>
        <p>
          The good news is, you can participate in these events or even host one while still making money on your
          listings. OneShop lets you do that and more! OneShop acts as your marketing expert 24/7 that lets you save
          time from doing laborious tasks of manually editing and uploading your listings on multiple online
          marketplaces.{' '}
        </p>
        <p>
          With OneShop, you can quickly draft, re-list, de-list, and monitor your listings hassle-free. It offers an
          all-in-one app with tools to help marketplace sellers sell more and earn more. To learn more about how you can
          save a day of work every week while selling on Poshmark, Mercari, Depop, and more, visit{' '}
          <a href='https://tools.oneshop.com/'>oneshop.com</a>.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
